module.exports = __webpack_public_path__ + "img/ws.89588991.svg";